/* eslint-disable no-restricted-imports -- This file is the designated entry point for sentry imports */
import { wrapSentryForProject, mapEnvironmentToDSN } from '@grantstreet/sentry-multiplex'
import { isProd } from '@grantstreet/psc-environment'

const dsns = {
  // announcements-vue-prod & -nonprod projects
  prod: 'https://22e87eb3d0f54e2f9da1960e807691fa@o168195.ingest.sentry.io/5943557',
  nonprod: 'https://70144fa819ec462f9bb3feec00fa1e8b@o168195.ingest.sentry.io/5943558',
}

// Also export the @grantstreet/sentry-multiplex way of doing things
const Sentry = wrapSentryForProject('announcements-vue', {
  dsn: () => mapEnvironmentToDSN(dsns, isProd),
})
export default Sentry
export const sentryException = Sentry.captureException
